export enum HighlightStyles {
  SEARCH = 'text-secondary-10 px-1 py-[2px] font-bold',
  KEYWORD = 'text-secondary-10 font-bold',
  TAG_KEYWORD = 'text-accent-active-secondary-10 font-bold',
  TAG_KEYWORD_WITH_BG = 'text-accent-active-secondary-10 font-bold bg-black/10',
  TAG_KEYWORD_FILTERED = 'text-feedback-success-20 font-bold',
}
